<template>
  <div>
    <form
      class="form"
      method="POST"
      action="javascript:;"
      @submit.prevent="submit"
    >
      <FormError v-if="formError.length > 0" :errorMessages="formError" />

      <FormLoading v-if="!formReady" />

      <CardBase v-else>
        <template #header>{{ $route.meta.title }}</template>
        <template #content>
          <FormRow class="mb-4" :required="true">
            <template #label>Assets</template>
            <template #field>
              <multiselect
                :options="listAsset"
                :loading="listAssetLoading"
                :class="$v.formData.assets.$error ? 'multiselect--error' : ''"
                :multiple="true"
                :close-on-select="false"
                track-by="id"
                label="name"
                placeholder="Search asset"
                v-model="formData.assets"
              >
                <template #noOptions>Enter asset name</template>
                <template #noResult>No results found</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.assets.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.assets.required"
                  >This field is required.</span
                >
              </div>
            </template>
            <template #help
              >This bank will only be available to the selected
              assets.</template
            >
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Bank Group</template>
            <template #field>
              <multiselect
                :allow-empty="false"
                deselectLabel=""
                :options="listBankGroup"
                :loading="listBankGroupLoading"
                :class="
                  $v.formData.bank_group.$error ? 'multiselect--error' : ''
                "
                track-by="id"
                label="name"
                tag-placeholder="Press enter to choose"
                placeholder="Choose bank group"
                v-model="formData.bank_group"
                @input="filterListBank"
              >
                <template #noResult>No results found.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.bank_group.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.bank_group.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Bank</template>
            <template #field>
              <multiselect
                :allow-empty="false"
                deselectLabel=""
                :options="listBank"
                :loading="listBankLoading"
                :class="$v.formData.bank.$error ? 'multiselect--error' : ''"
                track-by="id"
                label="name"
                tag-placeholder="Press enter to choose"
                placeholder="Choose bank"
                v-model="formData.bank"
                @input="checkChosenBank"
              >
                <template #noOptions v-if="!formData.bank_group"
                  >Please choose Bank Group</template
                >
                <template #noResult>No results found.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.bank.$error && formSubmitted"
              >
                <span class="form-error__text" v-if="!$v.formData.bank.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Category</template>
            <template #field>
              <multiselect
                :allow-empty="false"
                deselectLabel=""
                :options="listBankCategory"
                :loading="listBankCategoryLoading"
                :class="
                  $v.formData.bank_category.$error ? 'multiselect--error' : ''
                "
                track-by="id"
                label="name"
                tag-placeholder="Press enter to choose"
                placeholder="Choose bank category"
                v-model="formData.bank_category"
              >
                <template #noResult>No results found.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.bank_category.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.bank_category.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Type</template>
            <template #field>
              <multiselect
                :allow-empty="false"
                deselectLabel=""
                :options="listBankType"
                :loading="listBankTypeLoading"
                :class="
                  $v.formData.bank_type.$error ? 'multiselect--error' : ''
                "
                track-by="id"
                label="name"
                tag-placeholder="Press enter to choose"
                placeholder="Choose bank usage"
                v-model="formData.bank_type"
              >
                <template #noResult>No results found.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.bank_type.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.bank_type.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Service</template>
            <template #field>
              <multiselect
                :allow-empty="false"
                deselectLabel=""
                :options="listBankService"
                :loading="listBankServiceLoading"
                :class="
                  $v.formData.bank_service.$error ? 'multiselect--error' : ''
                "
                track-by="id"
                label="name"
                tag-placeholder="Press enter to choose"
                placeholder="Choose bank service"
                v-model="formData.bank_service"
              >
                <template #noResult>No results found.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.bank_service.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.bank_service.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Account holder</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.holder.$error && formSubmitted,
                }"
                type="text"
                class="form__input"
                placeholder="Account holder name"
                v-model="formData.holder"
                :readonly="isEmoneyNexusPay"
                :disabled="isEmoneyNexusPay"
              />
              <div
                class="form-error"
                v-if="$v.formData.holder.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.holder.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true" v-show="!isEmoneyNexusPay">
            <template #label>Account number</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.number.$error && formSubmitted,
                }"
                type="text"
                class="form__input"
                placeholder="Account number"
                v-model="formData.number"
              />
              <div
                class="form-error"
                v-if="$v.formData.number.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.number.required"
                  >This field is required.</span
                >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.number.numeric"
                  >Only numbers are allowed.</span
                >
                <span
                  class="form-error__text"
                  v-if="
                    !$v.formData.number.minLength.min ||
                    !v.formData.number.maxLength.max
                  "
                  >Account number must be between 8 to 16 digits.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true" v-if="formCreate">
            <template #label>Starting Balance</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.balance.$error && formSubmitted,
                }"
                type="text"
                class="form__input"
                placeholder="Starting Balance"
                v-model="formData.balance"
                v-currency="{
                  currency: null,
                  distractionFree: false,
                  allowNegative: false,
                  locale: 'en',
                }"
              />
              <div
                class="form-error"
                v-if="$v.formData.balance.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.balance.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Daily limit</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.limit_daily.$error && formSubmitted,
                }"
                type="text"
                class="form__input"
                placeholder="Daily limit"
                v-model="formData.limit_daily"
                v-currency="{
                  currency: null,
                  distractionFree: false,
                  allowNegative: false,
                  locale: 'en',
                }"
              />
              <div
                class="form-error"
                v-if="$v.formData.limit_daily.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.limit_daily.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Laundry limit</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.limit_laundry.$error && formSubmitted,
                }"
                type="text"
                class="form__input"
                placeholder="Laundry limit"
                v-model="formData.limit_laundry"
                v-currency="{
                  currency: null,
                  distractionFree: false,
                  allowNegative: false,
                  locale: 'en',
                }"
              />
              <div
                class="form-error"
                v-if="$v.formData.limit_laundry.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.limit_laundry.required"
                  >This field is required.</span
                >
              </div>
            </template>
            <template #help
              >Bank will be shown with a warning if balance exceeds this
              amount.</template
            >
          </FormRow>

          <FormRow class="mb-4" v-if="!formCreate">
            <template #label>Status</template>
            <template #field>
              <div>
                <label class="flex items-center mb-1 cursor-pointer">
                  <input
                    type="radio"
                    class="cursor-pointer"
                    name="status"
                    value="1"
                    v-model="formData.status"
                  />
                  <span class="ml-2 text-sm">Active</span>
                </label>
                <label class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    class="cursor-pointer"
                    name="status"
                    value="2"
                    v-model="formData.status"
                  />
                  <span class="ml-2 text-sm">Blocked</span>
                </label>
              </div>
            </template>
          </FormRow>

          <FormDataLog :data="formData" v-if="!formCreate" />
        </template>

        <template #footer>
          <FormRow class="mb-0">
            <template #field>
              <BaseButton type="submit">Submit</BaseButton>
            </template>
            <template #link>
              <div class="ml-4">
                or
                <router-link :to="{ name: 'BankAccountList' }" class="link ml-2"
                  >Back to List Bank</router-link
                >
              </div>
            </template>
          </FormRow>
        </template>
      </CardBase>
    </form>

    <Changelog v-if="!this.formCreate" />
  </div>
</template>

<script>
import { CurrencyDirective } from "vue-currency-input";
import {
  required,
  numeric,
  requiredIf,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { getListAssetMixin } from "@/mixins/getListAssetMixin";
import { getListBankOptionsMixin } from "@/mixins/getListBankOptionsMixin";
import { submitFormMixin } from "@/mixins/submitFormMixin";

import Multiselect from "vue-multiselect";
const prettyPrintJson = require("pretty-print-json");

export default {
  directives: {
    currency: CurrencyDirective,
  },
  mixins: [getListAssetMixin, getListBankOptionsMixin, submitFormMixin],
  components: {
    Multiselect,
  },
  data: () => {
    return {
      listAsset: [],
      listAssetLoading: true,

      formData: {
        assets: [],
        balance: 0,
        limit_daily: 100000000,
        limit_laundry: 3000000,
      },

      listLogs: [],
      listLogsLoading: true,
      listBankLoading: false,
    };
  },
  validations: {
    formData: {
      assets: {
        required,
      },
      bank_group: {
        required,
      },
      bank: {
        required,
      },
      bank_category: {
        required,
      },
      bank_type: {
        required,
      },
      bank_service: {
        required,
      },
      holder: {
        required,
      },
      number: {
        required: requiredIf(function(){
          return !this.isEmoneyNexusPay;
        }),
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(16),
      },
      limit_daily: {
        required,
      },
      limit_laundry: {
        required,
      },
      balance: {
        required: requiredIf(function () {
          return this.formCreate;
        }),
      },
    },
  },
  computed: {
    isEmoneyNexusPay() {
      return this.formData.bank && this.formData.bank.locked === true
    },
  },
  created() {
    this.getListAsset();
    this.getListBankGroup();
    this.getListBankType();
    this.getListBankCategory();
    this.getListBankService();
  },
  methods: {
    checkChosenBank(option) {
      if (option.locked === true) {
        this.formData.holder = option.name;
      } else {
        this.formData.holder = '';
      }
    },
    filterListBank(bankGroup) {
      delete this.formData.bank;
      this.getListBank(bankGroup.id);
    },
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.formData = { ...this.formData, ...data };
            this.formReady = true;

            this.getListBank(data.bank_group.id);
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
    printJson(data) {
      return data ? prettyPrintJson.toHtml(JSON.parse(data)) : "-";
    },
    getListLogs() {
      this.$http
        .get(
          process.env.VUE_APP_API_URL + this.$route.path.replace("edit", "log")
        )
        .then((res) => {
          if (res.status == 200) {
            this.listLogsLoading = false;

            const response = res.data;

            if (response) {
              this.listLogs = response;
            }
          }
        })
        .finally(() => {});
    },
  },
};
</script>
